// Copie locale de lecture. Écrite uniquement après une lecture réussie du serveur ;
// relue uniquement hors connexion ou en cas d’erreur, et toujours affichée comme telle.
import { validateContact, validateProfile } from '../core/contact';
import type { Snapshot } from './repo';

const KEY = (userId: string) => `a5w:cache:v1:${userId}`;

export interface Cache {
  read(userId: string): Snapshot | null;
  write(userId: string, snap: Snapshot): void;
  clear(userId: string): void;
}

export class LocalCache implements Cache {
  constructor(private readonly storage: Storage | null = typeof localStorage !== 'undefined' ? localStorage : null) {}

  read(userId: string): Snapshot | null {
    try {
      const raw = this.storage?.getItem(KEY(userId));
      if (!raw) return null;
      const parsed = JSON.parse(raw) as { readAt?: number; profile?: unknown; contacts?: unknown[] };
      if (!Number.isFinite(parsed.readAt) || !Array.isArray(parsed.contacts)) return null;
      const contacts = [];
      for (const c of parsed.contacts) { try { contacts.push(validateContact(c)); } catch { /* entrée illisible ignorée */ } }
      let profile = null;
      if (parsed.profile) { try { profile = validateProfile(parsed.profile); } catch { profile = null; } }
      return { readAt: parsed.readAt as number, profile, contacts };
    } catch { return null; }
  }

  write(userId: string, snap: Snapshot): void {
    try { this.storage?.setItem(KEY(userId), JSON.stringify(snap)); } catch { /* stockage indisponible : la copie locale est un confort, pas la vérité */ }
  }

  clear(userId: string): void {
    try { this.storage?.removeItem(KEY(userId)); } catch { /* rien */ }
  }
}

export class NoCache implements Cache {
  read(): Snapshot | null { return null; }
  write(): void { /* rien */ }
  clear(): void { /* rien */ }
}
